import { useCallback } from 'react';
import useApi from './useApi';
import { DraegerTubeItem } from '../types/DraegerTubeTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getDraegerTubes = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}GetDraegerTubes`,
            });
        } catch (error) {
            console.error('Failed to fetch draeger tubes:', error);
        }
    }, [getApiData]);

    // Get the draeger tubes data
    const getDraegerTubesData = (): DraegerTubeItem[] => {
        if (state.status === 'success' && state.result) {
            let rawDraegerTubes: any[] = [];
            if (Array.isArray(state.result)) {
                rawDraegerTubes = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawDraegerTubes = state.result.data;
            } else if (typeof state.result === 'object') {
                rawDraegerTubes = [state.result];
            }
            return rawDraegerTubes;
        }
        return [];
    };

    return {
        draegerTubes: getDraegerTubesData(),
        loading: state.isLoading,
        error: state.error,
        getDraegerTubes,
        status: state.status,
    };
};
